<template>
  <b-modal class="modal-md" id="confirmDeletionConfirm" ref="confirmDeletionConfirm-modal" :title="'Delete Payment Configuration'" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" @hide="closeModal()">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fas', 'money-check']" size="1x" class="mr-2"/> Delete Payment Configuration</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default" slot-scope="{ close }">
      <h5>Are you sure you want to delete {{ $props.configKey }} from the configuration?</h5>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel, close }">
      <div>
        <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary mr-2" type="button" @click="cancel()">
          <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>Cancel
        </button>
        <button aria-label="AddPaymentConfiguration" data-dismiss="modal" class="btn btn-primary" type="button" @click="confirmConfigurationDelete()">
          <fontAwesomeIcon :icon="['fa', 'save']" class="text-light mr-2" />Delete Configuration
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
  name: 'ModalConfigurationDeleteConfirmation',
  props: ['paymentMethod', 'configId', 'configKey'],
  data () {
    return {
      
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo'])
  },
  methods:{
    closeModal() {
      this.$parent.closeModal()
    },

    confirmConfigurationDelete() {
      this.$parent.deleteConfiguration(this.$props.configId)
    }
  },
  created() {

  },
  components: {
    
  }
}
</script>

<style scoped>
.flex-align {
  display: flex;
  align-items: center;
}

.remove-icon {
  font-size: 24px;
  color: red;
  cursor: pointer;
}
</style>
